import React from "react";

import "./index.css";
import BsyMsgBubble from "../BsyMsgBubble";
import { BsyUtils } from "../../utils/Utils";
import { BsyWidget } from "../BsyWidget";
import BsySLoading from "../BsySLoading";
import BsyTextEditor from "../BsyTextEditor";
import { BsyConfig } from "../../global/BsyConfig";

export default class BsySelect extends BsyWidget {
  static defaultProps = {
    // minWidth: 100,
    async: null,
    // authGroupId: null,
    baseCls: "BsySelect",
    waterMark: null,
    textField: "text",
    valueField: "value",
    hasSelectEmpty: false,
    asyncResultKey: "items", // props.asyncResultKey ? props.asyncResultKey : "items",
    allowBlank: !0,
    searchable: !0,
    onStopEdit: null,
    type: "combo",
    height: 30,
    // width: 350,
    edge: {
      width: 350,
      height: 200,
    },
    upWidth: null,
    limit: 200,
    hasLimit: !1,
    searchKey: "keyword",
    hasScrollLoad: !1,
    onAsyncSuccess: null,
    value: null,
    customCls: "",

    items: [],
    colorEnable: false,
    prohibit: false,
  };
  rebuild = () => {
    this.options.cssName = this.options.baseCls + " " + this.options.widgetName;
    if (!this.isEnabled()) {
      this.options.cssName += " bsy-ui-disable";
    }
    if (!this.isVisible()) {
      this.options.cssName += " bsy-ui-hidden";
    }
    if (this.options.customCls) {
      this.options.cssName += " " + this.options.customCls;
    }

    this.options.css = {};
    if (this.options.height) this.options.css.height = this.options.height;
    if (this.options.width) this.options.css.width = this.options.width;
    // this.options.css.lineHeight = this.options.lineHeight + 'px';
    let obj = this.getDefaultValue();
    this.setState({ ...obj });
  };
  constructor(props) {
    super({
      emptySelectText: React.language("unfilled"),
      ...props,
    });

    this.page = 0;

    this.seachRef = React.createRef();
    this.isEditd = false;
    this.otherTextRef = React.createRef();
    this.otherText = "";
    this.otherItem = null;

    let obj = this.getDefaultValue();
    this.state = {
      css: {},
      showList: false,
      seaching: false,
      // value: this.getDefaultValue(),// this.options.value,
      prohibit: this.options.prohibit,
      ...obj,
      uuid: `BsySelect-${this.uuid}`,
    };
  }

  doFilterRely = (t, rel, widgetFilter) => {
    if (this.options.async) {
      if (this.options.async.data) {
        if (t) {
          this.options.async.data.filter = t;
        }
        if (widgetFilter) {
          this.options.async.data.widget.filter = widgetFilter;
        }
        if (rel) {
          if (this.options.async.data.filter) {
            this.options.async.data.filter.rel = rel;
          }
        }
      }
    }

    this.setState({
      items: [],
    });
  };

  setLoadItems = () => {
    this.setState({
      items: [],
    });
  };

  loadData = (skip, cb) => {
    const {
      async,
      hasLimit,
      limit,
      authGroupId,
      type,
      popupFormPath,
      asyncResultKey,
      textField,
      valueField,
      hasSelectEmpty,
      emptySelectText,
      rely,
    } = this.options;
    this.isMore = false;
    let that = this;
    let b = this.options;
    if (BsyUtils.isObjectEmpty(async)) {
      this.setState(
        {
          items: [],
          showList: false,
        },
        () => {
          cb && cb();
        }
      );
      return;
    }

    let filter = BsyUtils.applyFunc(
      this,
      this.props.onBeforeAsync,
      ["", null, this],
      !1
    );
    let data = async.data ? JSON.parse(JSON.stringify(async.data)) : {};

    if (rely) {
      if (rely.data) {
        if (rely.version) {
          data.rel = rely.data.rel;
        } else {
          data.rel = "and";
        }
        data.filter = {};
        if (data && !BsyUtils.isObjectEmpty(filter)) {
          data.filter = filter;
        }
      } else {
        //关联其他表数据，有筛选条件
        if (filter) {
          if (filter.rel == "and") {
            let isEmpty = false;
            BsyUtils.forEach(filter.cond, (key, item) => {
              if (["empty", "not_empty"].indexOf(item.method) > -1) {
                return;
              }
              if (BsyUtils.isObjectEmpty(item.value)) {
                isEmpty = true;
                return false;
              }
            });
            //有空就不请求
            if (isEmpty) data.filter = {};
            else data.filter = filter;
          } else if (filter.rel == "or") {
            let isEmpty = true;
            BsyUtils.forEach(filter.cond, (key, item) => {
              if (["empty", "not_empty"].indexOf(item.method) > -1) {
                isEmpty = false;
                return false;
              }
              if (!BsyUtils.isObjectEmpty(item.value)) {
                isEmpty = false;
                return false;
              }
            });
            //全部为空就不请求
            if (isEmpty) data.filter = {};
            else data.filter = filter;
          }
        } else {
          data.filter = null;
        }
      }
    }
    // else {
    //     if (!BsyUtils.isObjectEmpty(filter)) {
    //         data.filter = filter;
    //     }
    // }

    // 快捷编辑使用 onBeforeAsync
    if (data && data.filter && BsyUtils.isObjectEmpty(data.filter)) {
      this.setState(
        {
          items: [],
          showList: false,
        },
        () => {
          cb && cb();
        }
      );
      return;
    }

    let n = {
      hasLimit: hasLimit,
      authGroupId: authGroupId,
      popupFormPath: popupFormPath ? [...popupFormPath] : undefined,
      ...data,
      limit: limit,
      skip: skip,
      systemFilter: false,
      jsplatform: data.filter
        ? data.filter.hasOwnProperty("cond")
          ? "React"
          : undefined
        : undefined,
      isNewFilter: data.filter
        ? data.filter.hasOwnProperty("cond")
          ? true
          : false
        : false,
    };

    if (["combo", "combocheck"].indexOf(this.options.type) > -1) {
      n.popupFormPath = undefined;
    }

    n.widgetName = this.options.widgetName;
    n.subformName = this.options.subform;

    if (this.options.designAppId) {
      n.designAppId = this.options.designAppId;
      n.designEntryId = this.options.designEntryId;
      n.widgetName = b.orgWidgetName || b.widgetName;
      n.subformName = b.subformName || b.subform;
    }

    if (window.FX.STATIC.QTOKEN) {
      n.authGroupId = undefined;
      n.popupFormPath = undefined;
      n.systemFilter = false;
      n.hasLimit = undefined;
      n.limit = undefined;
      n.skip = undefined;
    }

    if (["combo", "combocheck"].indexOf(this.options.type) > -1) {
      n.popupFormPath = undefined;
    }

    n.widgetName = this.options.widgetName;
    n.subformName = this.options.subform;

    if (this.options.designAppId) {
      n.designAppId = this.options.designAppId;
      n.designEntryId = this.options.designEntryId;
      n.widgetName = b.orgWidgetName || b.widgetName;
      n.subformName = b.subformName || b.subform;
    }

    if (window.FX.STATIC.QTOKEN) {
      n.authGroupId = undefined;
      n.popupFormPath = undefined;
      n.systemFilter = false;
      n.hasLimit = undefined;
      n.limit = undefined;
      n.skip = undefined;
    }

    if (n.hasOwnProperty("hasCurrentUser")) {
      if (
        BsyUtils.isObjectEmpty(n.filter) ||
        BsyUtils.isObjectEmpty(n.filter.cond)
      )
        n.hasCurrentUser = true;
      else {
        n.hasCurrentUser = false;
      }
    }
    if (!BsyUtils.isObjectEmpty(this.searchValue)) {
      n.keyword = this.searchValue + "";
      if (n.hasOwnProperty("hasCurrentUser")) {
        n.hasCurrentUser = false;
      }
    }

    React.axios(
      async.url,
      {
        ...n,
      },
      { cancelTokenTs: this.cancelTokenTs }
    )
      .then((res) => {
        BsyUtils.showAjaxTip(res.data, () => {
          let dd = [];

          if (!this.searchValue && hasSelectEmpty) {
            if (skip === 0) {
              that.valueMap = {};
              dd.push({
                [textField]: emptySelectText,
                [valueField]: BsyConfig().CONST.PARAMETER.EMPTY,
              });
            }
          }

          if (
            BsyUtils.isObjectEmpty(this.searchValue) &&
            this.props.onAfterAsync
          ) {
            dd = this.props.onAfterAsync(dd);
          }
          //还有更多数据
          if (res.data[asyncResultKey])
            this.isMore = res.data[asyncResultKey].length === n.limit;
          BsyUtils.forEach(res.data[asyncResultKey], (a1, b1) => {
            if (b1)
              if (BsyUtils.isString(b1) || BsyUtils.isNumber(b1)) {
                that.valueMap[b1] = b1 + "";
                dd.push({
                  [textField]: b1 + "",
                  [valueField]: b1 + "",
                });
              } else {
                if (b1 && (b1.status === -99 || b1.status === -2)) {
                  dd.push({
                    ...b1,
                    [textField]: BsyUtils._toDeptUser(b1, "user"),
                    [valueField]: b1[valueField],
                  });
                } else {
                  that.valueMap[b1[valueField]] = b1[textField];
                  dd.push({
                    ...b1,
                    [textField]: b1[textField],
                    [valueField]: b1[valueField],
                  });
                }
              }
          });
          let ddc = [];

          if (skip > 0) {
            if (this.state.items) ddc = [...this.state.items];
          }
          ddc = ddc.concat(dd);
          BsyUtils.forEach(ddc, (a1, b1) => {
            that.valueMap[b1[valueField]] = b1[textField];
          });
          this.setState(
            {
              items: ddc,
              showList: false,
            },
            () => {
              cb && cb();
            }
          );
        });
      })
      .catch((res) => {
        console.error(res);
      });
  };

  showLoading = (currentTarget) => {
    console.log(this.props.upWidth)
    let width = this.element.current.offsetWidth;
    let that = this;
    BsyMsgBubble({
      anchor: currentTarget,
      contentHTML: (ref) => {
        that.showLoadingHandle = ref;
        return (
          <div style={{ height: 40 }}>
            <BsySLoading customCls={"small"} />
          </div>
        );
      },
      text4Cancel: null,
      text4Ok: null,
      theme: this.props.theme,
      minWidth: width,
      width: that.props.upWidth || (width < 350 ? 350 : width),
      contentPadding: 0,
      edge: 200,
      hAdjust: 72,
      dockPosition: "left",
      onClose: function () {
        // that.setState({
        //     showList: !1,
        // })
        return !1;
      },
    });
  };

  onMoreData = (cb) => {
    this.page++;
    const { async, limit } = this.options;
    this.loadData(this.page * limit, () => {
      cb && cb(this.state.items, this.isMore);
    });
  };

  clear = (event) => {
    event.stopPropagation();
    event.preventDefault();
    this.value = "";
    this.selectOther = false;
    this.otherText = "";
    this.setState(
      {
        value: "",
        showList: false,
      },
      () => {
        BsyUtils.applyFunc(
          this,
          this.options.onStopEdit,
          [this.value, null, this],
          !1
        );
      }
    );
  };

  showCombo = (currentTarget) => {
    const {
      searchable,
      textField,
      valueField,
      allowBlank,
      hasSelectEmpty,
      emptySelectText,
      onCustomItem,
      colorEnable,
      dataOther,
      dataOtherPos,
      subform,
      isFormType,
      onCustomList,
      notSelectClose,
    } = this.options;
    const { items, value } = this.state;
    let width = this.element.current.offsetWidth;
    let height = this.element.current.offsetHeight < 32 ? 32 : this.element.current.offsetHeight;
    let that = this;
    that.isEditd = false;
    let bubbleRef = React.createRef();
    // console.log("that.props.upWidth", that.props.upWidth)
    BsyMsgBubble({
      anchor: currentTarget,
      contentHTML: (ref) => {
        if (that.showLoadingHandle) {
          that.showLoadingHandle.closeAlter();
          that.showLoadingHandle = null;
        }
        return (
          <TriggerComboPane
            colorEnable={colorEnable}
            ref={bubbleRef}
            itemHeight={height}
            dataOther={dataOther}
            dataOtherPos={dataOtherPos}
            selectOther={this.selectOther}
            otherItem={this.otherItem}
            items={items}
            textField={textField}
            valueField={valueField}
            searchable={searchable}
            allowBlank={allowBlank}
            isFormType={isFormType}
            subform={subform}
            isMore={this.isMore}
            hasSelectEmpty={hasSelectEmpty}
            emptySelectText={emptySelectText}
            onCustomItem={onCustomItem}
            onCustomList={onCustomList}
            searchValue={that.searchValue}
            value={BsyUtils.isObjectEmpty(value) ? null : value}
            onSelect={(val) => {
              that.isEditd = true;
              that.selectItem(val);
              !notSelectClose && ref.closeAlter();
            }}
            onSeach={this.onSeach}
            onMoreData={this.onMoreData}
          />
        );
      },
      text4Cancel: null,
      text4Ok: null,
      theme: this.props.theme,
      minWidth: width,
      width: that.props.upWidth || (width < 160 ? 160 : width),
      contentPadding: 0,
      edge: 200,
      hAdjust: 72,
      dockPosition: "left",
      onClose: function (e) {
        that.hasFocus = false;
        if (
          e &&
          e.target &&
          e.target.classList.contains("icon-dingding-guide-close")
        ) {
          // this.selectOther = false;
          // that.setState({
          //     value: null,
          // }, () => {
          //     BsyUtils.applyFunc(that, that.props.onStopEdit, ['', null, that], !1)
          // })
          that.clear(e);
          that.setState({
            showList: !1,
          });
          return !1;
        } else {
          if (!that.isEditd) {
            BsyUtils.applyFunc(
              that,
              that.props.onClose,
              [that.state.value, null, that],
              !1
            );
          }
        }
        if (subform && bubbleRef && bubbleRef.current) {
          that.selectOther = bubbleRef.current.options.selectOther;
          if (that.selectOther) {
            that.otherText = bubbleRef.current.otherTextRef.current.getValue();
            BsyUtils.applyFunc(
              that,
              that.props.onStopEdit,
              [that.otherText, null, that],
              !1
            );
          }
        }
        that.setState({
          showList: !1,
        });
        return !1;
      },
    });
  };

  autoSelectList = (event) => {
    const { async, limit } = this.options;
    const { prohibit } = this.state;
    let that = this;
    const { showList, items } = this.state;
    that.hasFocus = true;
    if (!prohibit) {
      if (showList) {
        if (that.showLoadingHandle) {
          that.showLoadingHandle.closeAlter();
          that.showLoadingHandle = null;
        }
        that.setState(
          {
            showList: false,
          },
          () => {
            if (that.props.onStopEdit) {
              that.hasFocus = false;
              that.props.onStopEdit(that.getValue(), null, that);
            }
          }
        );
      } else {
        let currentTarget = event.currentTarget;
        if (async) {
          this.showLoading(currentTarget);
          this.loadData(this.page * limit, () => {
            const { showList } = this.state;

            if (showList) {
              return;
            }
            this.setState(
              {
                showList: true,
              },
              () => {
                that.showCombo(currentTarget);
              }
            );
            return;
          });
        } else {
          if (!showList) {
            this.setState(
              {
                showList: true,
              },
              () => {
                that.showCombo(currentTarget);
              }
            );
          }
        }
      }
    }
  };

  onSeach = (val, cb) => {
    const { async, textField } = this.options;
    const { items } = this.state;
    this.searchValue = val;

    if (async) {
      this.page = 0;
      this.loadData(0, () => {
        cb && cb([...this.state.items], this.isMore);
        return;
      });
      return;
    } else {
      if (BsyUtils.isObjectEmpty(val)) {
        this.setState(
          {
            items: [...this.bakAllitems],
            seaching: false,
          },
          () => {
            cb && cb([...this.state.items]);
          }
        );
        this.bakAllitems = null;
        return;
      }

      if (BsyUtils.isObjectEmpty(this.bakAllitems)) {
        this.bakAllitems = [...items];
      }
      const searchValue = this.bakAllitems.filter((data, index) => {
        if (data[textField] && (data[textField] + "").indexOf(val) > -1) {
          return true;
        }
        return false;
      });
      cb && cb([...searchValue]);
    }
  };

  componentDidMount() {
    super.componentDidMount();
    this.props.getValue && this.props.getValue(this);
    const { valueField, textField } = this.options;
    const { items } = this.state;
    let that = this;
    that.valueMap = {};
    BsyUtils.forEach(items, (a1, b1) => {
      that.valueMap[b1[valueField]] = b1[textField];
    });
  }

  selectItem = (val) => {
    const { listLimitChange, valueField } = this.options;
    this.isEditd = this.state.value !== val[valueField];
    this.value = val[valueField];
    this.setState({ value: val[valueField], showList: false }, () => {
      listLimitChange && listLimitChange(val[valueField]);
      if (this.props.onStopEdit) {
        this.props.onStopEdit(
          BsyUtils.isObjectEmpty(val[valueField]) ? null : val[valueField],
          null,
          this
        );
      }
    });
  };

  getValue = () => {
    return BsyUtils.isObjectEmpty(this.value) ? null : this.value;
  };

  setValue = (t) => {
    this.value = t;
    this.setState({
      value: t,
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    //防止多次重复 setState
    let props = {};
    if (nextProps.value !== this.state.value) {
      props.value = nextProps.value;
    }

    let items = nextProps.items || [];

    if (items && !BsyUtils.compare(items, this.state.items)) {
      this.options.value = this.value;
      this.options.items = [...items];
      // props.items = items && [...items];
      const obj = this.getDefaultValue();
      props = { ...props, ...obj };
    }
    if (!BsyUtils.isObjectEmpty(props)) {
      this.setState({
        ...props,
      });
    }
  }

  showItem = () => {
    const { textField, valueField } = this.options;
    const { items, value } = this.state;
    let text = [];
    // if (BsyUtils.isObjectEmpty(value)) {
    //     return text;
    // }
    items &&
      items.map((val) => {
        // if (BsyUtils.isObjectEmpty(value)) {
        //     // if (val.selected)
        //         !BsyUtils.isObjectEmpty(val[valueField]) && (text = val[textField]);
        // } else {
        if (val[valueField] === value)
          !BsyUtils.isObjectEmpty(val[valueField]) && (text = val[textField]);
        // }
      });
    if (BsyUtils.isObjectEmpty(text)) {
      if (value == "fx_param_empty") {
        text = this.options.emptySelectText;
      } else {
        if (BsyUtils.isObjectEmpty(value)) {
          text = "";
        } else {
          text = [value];
        }
      }
    }
    return text;
  };

  render() {
    const { minWidth, cssName, css, waterMark, hasClearSelect } = this.options;
    const { showList, prohibit } = this.state;
    let text = this.showItem();
    if (!this.isEnabled()) {
      return this.renderDisablePane(text);
    }
    return (
      <div
        className={cssName + " " + (showList ? "open" : "")}
        style={{
          minWidth: minWidth,
          opacity: prohibit ? "0.5" : "",
          ...css,
        }}
        ref={this.element}
        onClick={this.autoSelectList}
      >
        <div className="showText" style={{ border: prohibit ? "none" : "" }}>
          <div className="selectShowText">
            {text === "" ||
              (Array.isArray(text) && text.length <= 0) ||
              text === undefined ||
              text === null ? (
              <span className="waterMark">{waterMark}</span>
            ) : (
              <span>{Array.isArray(text) ? text.join(",") : text}</span>
            )}
          </div>

          {!prohibit && (
            <div
              className={
                "iconSelect " + (text && hasClearSelect ? "has-value" : "")
              }
            >
              <i
                className="icon-bsy-xiala"
                style={{
                  transform: showList ? "rotateX(180deg)" : "",
                }}
              >
                {" "}
              </i>

              {/* <i className="icon-bsy-xiala">  </i> */}
              <i
                className="widget-icon icon-dingding-guide-close"
                onClick={this.clear}
              ></i>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export class TriggerComboPane extends BsyWidget {
  constructor(props) {
    super({
      // minWidth: 100,
      baseCls: "bsy-trigger-pane",
      waterMark: null,
      textField: "text",
      valueField: "value",
      emptySelectText: React.language("unfilled"),
      allowBlank: !0,
      searchable: !0,
      selectOther: false,
      otherItem: {
        value: React.language("other.ext"),
        text: React.language("other.ext"),
      },
      onStopEdit: null,
      height: 200,
      itemHeight: 34,
      hasSelectOther: false,
      searchKey: "keyword",
      hasScrollLoad: !1,
      onAsyncSuccess: null,
      value: props.value,
      searchValue: "",
      customCls: "",
      colorEnable: false,
      ...props,
    });
    let fItems = this.options.items.filter((item) => {
      return item[props.valueField] === props.value;
    });
    this.state = {
      css: {},
      seaching: false,
      value: props.value,
      items: props.value
        ? fItems.length
          ? this.options.items
          : [
            ...this.options.items,
            {
              [this.options.textField]: props.value,
              [this.options.valueField]: props.value,
            },
          ]
        : this.options.items,
      isMore: props.isMore || false,
    };
    this.searchValue = this.options.searchValue;
    this.seachRef = React.createRef();
    this.listRef = React.createRef();
    this.otherTextRef = React.createRef();
    this.otherText = props.selectOther ? props.value : "";
    // this.hasOtherRender = false;
  }

  // getDefaultValue = (item) => {
  //     let val = '';
  //     BsyUtils.forEach(item, (index, data) => {
  //         if (data.selected) {
  //             val = data.value
  //             return false;
  //         }
  //     })
  //     return val
  // }

  componentDidMount() {
    super.componentDidMount();
    setTimeout(() => {
      this.seachRef.current && this.seachRef.current.focus();
    }, 200);
  }

  selectItem = (val, e) => {
    e && e.stopPropagation();
    if (val.isOther) {
      this.options.selectOther = true;
    } else {
      this.options.selectOther = false;
    }
    this.setState({ value: val[this.props.valueField] }, () => {
      this.props.onSelect && this.props.onSelect(val);
    });
  };

  seachItems = (e) => {
    let that = this;
    if (this.searchValue !== e.target.value) {
      this.searchinterval && clearTimeout(this.searchinterval);
      this.searchValue = e.target.value;
      this.setState({
        seaching: true,
      });
      this.searchinterval = setTimeout(function () {
        that.seachCallBack();
      }, 500);
    }
  };

  seachCallBack = () => {
    let that = this;

    this.props.onSeach
      ? this.props.onSeach(this.searchValue, (seachItems, isMore) => {
        that.setState(
          {
            items: [...seachItems],
            seaching: false,
            isMore: isMore,
          },
          () => {
            that.checkIsAllSelect && that.checkIsAllSelect();
          }
        );
      })
      : this.localSearch(this.searchValue, (seachItems) => {
        that.setState(
          {
            items: [...seachItems],
            seaching: false,
          },
          () => {
            that.checkIsAllSelect && that.checkIsAllSelect();
          }
        );
      });
  };

  localSearch = (val, cb) => {
    const { textField } = this.options;
    const { items } = this.state;
    this.searchValue = val;
    if (BsyUtils.isObjectEmpty(val)) {
      this.setState(
        {
          items: [...this.bakAllitems],
          seaching: false,
        },
        () => {
          cb && cb([...this.state.items]);
        }
      );
      this.bakAllitems = null;
      return;
    }

    if (BsyUtils.isObjectEmpty(this.bakAllitems)) {
      this.bakAllitems = [...items];
    }

    const searchValue = this.bakAllitems.filter((data, index) => {
      if (data[textField] && (data[textField] + "").indexOf(val) > -1) {
        return true;
      }
      return false;
    });
    cb && cb([...searchValue]);
  };

  renderOtherItem = () => {

    // if (this.hasOtherRender) {
    //   return;
    // }

    // this.hasOtherRender = true;

    let {
      selectOther,
      subform,
      otherItem,
      colorEnable,
      textField,
      valueField,
    } = this.options;

    if (BsyUtils.isObjectEmpty(otherItem)) {
      otherItem = {
        isOther: true,
        [valueField]: React.language("other.ext"),
        [textField]: React.language("other.ext"),
      };
    }

    return (
      <div
        key={"___ohter"}
        style={{
          height: this.options.itemHeight
        }}
        onClick={(e) => {
          if (!subform) {
            this.selectItem(otherItem, e);
          } else {
            this.options.selectOther = true;
            this.value = null;
            this.setState({ value: this.value }, () => {
              setTimeout(() => {
                if (this.otherTextRef && this.otherTextRef.current)
                  this.otherTextRef.current.focus();
              }, 30);
            });
          }
        }}
        className={selectOther ? "item select item-other" : "item item-other"}
      >
        {colorEnable ? (
          <span
            className=" bsy-text-tag l middle single-line "
            style={{
              background: "#e0e0e0",
              color: "#333",
              border: "1px solid var(--bsy-base-border-color) ",
            }}
          >
            {otherItem.text}
          </span>
        ) : (
          <span className="text" style={{ color: "#333" }}>
            {otherItem.text}
          </span>
        )}
        {subform ? (
          <BsyTextEditor
            ref={this.otherTextRef}
            value={this.otherText}
            height={30}
            onStopEdit={(val) => {
              this.otherText = val;
              // BsyUtils.applyFunc(this, this.props.onStopEdit, [val, null, this], !1)
            }}
          ></BsyTextEditor>
        ) : (
          ""
        )}
        {selectOther ? <i className={"icon-ok"}></i> : ""}
      </div>
    );
  };

  getFormTypeText = (t) => {
    switch (t) {
      case "extend":
        return React.language("referenceExtend.label");
      case "form":
        return React.language("form");
      case "dash":
        return React.language("dash.report");
      case "etl":
      case "etl_table":
        return React.language("editer_view");
      case "scenes":
        return React.language("scenes.report");
      case "aggregate_table":
        return React.language("app.category.aggregate");
      default:
    }
  };

  renderList = () => {
    const {
      textField,
      valueField,
      colorEnable,
      dataOther,
      dataOtherPos,
      onCustomList,
    } = this.options;
    const { items, value, seaching, isMore } = this.state;

    // dataOther={dataOther}
    // dataOtherPos={dataOtherPos}
    return (
      <>
        {!seaching && items ? (
          <>
            {onCustomList ? (
              onCustomList(this)
            ) : (
              <>
                {dataOther && !dataOtherPos ? this.renderOtherItem() : ""}
                {items.length ? (
                  items.map((val) => {
                    let selected = val[valueField] === value;

                    if (this.props.onCustomItem) {
                      return (
                        <div
                          key={val[valueField]}
                          onClick={(e) => {
                            this.selectItem(val, e);
                          }}
                          className={
                            selected
                              ? `item ${this.props.isFormType ? "isFormType" : ""
                              } select`
                              : `item ${this.props.isFormType ? "isFormType" : ""
                              }`
                          }
                        >
                          {this.props.onCustomItem(val)}
                          {!this.props.isFormType && selected ? (
                            <i className={"icon-ok"}></i>
                          ) : (
                            ""
                          )}
                          {this.props.isFormType && (
                            <span className={`formType ${val.formType}`}>
                              {this.getFormTypeText(val.formType)}
                            </span>
                          )}
                        </div>
                      );
                    }

                    if (val.isOther) {
                      return this.renderOtherItem();
                    }

                    return (
                      <div
                        key={val[valueField]}
                        onClick={(e) => {
                          this.selectItem(val, e);
                        }}
                        className={
                          (selected
                            ? `item ${this.props.isFormType ? "isFormType" : ""
                            } select`
                            : `item ${this.props.isFormType ? "isFormType" : ""
                            }`) +
                          (val.invalid ? " invalid " : "") +
                          (val.customCls ? " " + val.customCls : "")
                        }
                        style={{
                          height: this.options.itemHeight
                        }}
                      >
                        {colorEnable ? (
                          val.color ? (
                            <span
                              className=" bsy-text-tag l middle single-line "
                              style={{
                                background: val.color,
                                color: "#fff",
                                border: "1px solid " + val.color,
                              }}
                              title={val[textField]}
                            >
                              {val[textField]}
                            </span>
                          ) : (
                            <span
                              className=" bsy-text-tag l middle single-line "
                              style={{
                                background: "#e0e0e0",
                                color: "#333",
                                border: "1px solid var(--bsy-base-border-color) ",
                              }}
                              title={val[textField]}
                            >
                              {val[textField]}
                            </span>
                          )
                        ) : (
                          <span className="text" title={val[textField]}>
                            {val[textField]}
                          </span>
                        )}

                        {val.tip && <span className="text-tip">{val.tip}</span>}
                        {!this.props.isFormType && selected ? (
                          <i className={"icon-ok"}></i>
                        ) : (
                          ""
                        )}
                        {this.props.isFormType && (
                          <span className={`formType ${val.formType}`}>
                            {this.getFormTypeText(val.formType)}
                          </span>
                        )}
                      </div>
                    );
                  })
                ) : this.searchValue ? (
                  <div className="seach-data-empty">
                    {React.language("address.seach.empty")}
                  </div>
                ) : (
                  ""
                )}
                {dataOther && dataOtherPos ? this.renderOtherItem() : ""}
              </>
            )}
          </>
        ) : (
          ""
        )}
        {!seaching && isMore ? (
          <div className="loading">{React.language("loading")}</div>
        ) : (
          ""
        )}
      </>
    );
  };

  onScroll = (e) => {
    const { isMore } = this.state;

    if (isMore) {
      if (this.listRef && this.listRef.current) {
        if (
          this.listRef.current.offsetHeight <=
          e.target.scrollTop + e.target.offsetHeight + 10
        ) {
          this.setState(
            {
              isMore: false,
            },
            () => {
              if (this.props.onMoreData) {
                this.props.onMoreData((items, isMore) => {
                  this.setState({
                    items: [...items],
                    isMore: isMore,
                  });
                });
              }
              console.log("操作更多");
            }
          );
        }
      }
    }
  };

  render() {
    const { cssName, allowBlank, searchable } = this.options;
    const { seaching } = this.state;
    this.srkey = this.page === 0 ? "dfe" + new Date().getTime() : this.srkey;
    return (
      <div className={cssName}>
        {searchable ? (
          <div className="bsy-combo-search">
            <input
              ref={this.seachRef}
              onChange={this.seachItems}
              value={this.searchValue}
            // defaultValue={searchValue}
            ></input>
            <i className="icon-bsy-reportmenu-0"></i>
            {this.searchValue ? (
              <i
                className="widget-icon icon-dingding-guide-close"
                onClick={(e) => {
                  this.setState({
                    seaching: true,
                  });
                  this.searchValue = "";
                  this.seachCallBack();
                }}
              ></i>
            ) : (
              ""
            )}
          </div>
        ) : (
          <></>
        )}
        <div
          className="bsy-select-list"
          // style={{
          //   maxHeight: 250,
          //   maxWidth: 500,
          //   overflow: "auto",
          //   paddingBottom: 6,
          // }}
          key={this.srkey}
          onScroll={this.onScroll}
        >
          {seaching && (
            <div className="loading-text">
              <span>{React.language("searching")}</span>
            </div>
          )}
          <div style={{ overflow: "hidden" }} ref={this.listRef}>
            {!seaching && allowBlank ? (
              <div
                key={"empty"}
                onClick={(e) => {
                  this.selectItem("", e);
                }}
                className={"item"}
                style={{
                  height: this.options.itemHeight,
                  fontSize: 14,
                  fontWeight: "bold",
                }}
              >
                {React.language("select1")}
              </div>
            ) : (
              <></>
            )}
            {this.renderList()}
          </div>
        </div>
      </div>
    );
  }
}
